import { hostsConfig } from '@openeducation/oe-rn-services';
import type { Environment } from '@openeducation/oe-rn-services';
import axios from 'axios';

import type { AskTeacherQuestion } from '../../interfaces/ask-teacher-question';

type CountResponse = number | { count: number };

export default abstract class AskTeacherDao {
  static async getQuestionsCount(env: Environment, teacherId: number) {
    const url = hostsConfig[env].wolverineServiceUrl;
    const { data } = await axios.get<CountResponse>(
      `${url}/feedback/teachers/${teacherId}/questions/count?requestType=question`
    );

    if (typeof data === 'object') {
      return data.count;
    }

    return data;
  }

  static async getNextQuestion(env: Environment, teacherId: number) {
    const url = hostsConfig[env].wolverineServiceUrl;
    const { data } = await axios.get<AskTeacherQuestion>(
      `${url}/feedback/teachers/${teacherId}/questions/next?requestType=question`
    );

    return data;
  }

  static async answerQuestion(
    env: Environment,
    answer: string,
    teacherId: number,
    questionId: string
  ) {
    const url = hostsConfig[env].wolverineServiceUrl;
    const { data } = await axios.put<void>(
      `${url}/feedback/teachers/${teacherId}/questions/${questionId}`,
      answer
    );

    return data;
  }
}
